import { useEffect, useRef, useState } from "react";
import Footer from "../../Components/Footer";
import Navbar2 from "../../Components/Navbar2";
import "../Delhi-Ielts/Delhi-ielts.css";
import {
  FaBuilding,
  FaSignal,
  FaMapMarkerAlt,
  FaClock,
  FaCompass,
  FaPhone,
} from "react-icons/fa";
import { FaBookOpen, FaCommentDots, FaChartBar } from "react-icons/fa";
import { FaTrophy, FaUsers, FaRegClock } from "react-icons/fa";
import { FaSun, FaRegCalendarAlt } from "react-icons/fa";
import { MdWbTwilight } from "react-icons/md";
import { LuTarget } from "react-icons/lu";
import { MdLocationPin } from "react-icons/md";
import { MdOutlineEditNote } from "react-icons/md";
import { LuBot } from "react-icons/lu";
import { MdRocketLaunch } from "react-icons/md";
import { LuUsers2 } from "react-icons/lu";
import Slider from "react-slick/lib/slider";
import { FaPhoneAlt, FaBullseye } from "react-icons/fa";
import { DetailsFormJSon } from "../LandingPage/LandingPageModel";
import { useDispatch } from "react-redux";
import { Test_Book } from "../../Action/ContactAction";
import { TEST_BOOKING_RESET } from "../../Constant/ContactConstant";
import { useSelector } from "react-redux";
import Loading from "../../Components/Loading";
import { Helmet } from "react-helmet";

export default function DelhiIelts() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [StudentForm, setStudentForm] = useState(DetailsFormJSon);
  const Mobile_Screen = window.innerWidth;
  const dispatch = useDispatch();
  const why_choose = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 600,
    afterChange: (current) => setCurrentSlide(current),
    slidesToShow: Mobile_Screen <= 480 ? 1 : 3,
    slidesToScroll: 1,
  };
  const { loading, success, error } = useSelector((s) => s.Test_Book_Reducer);
  const formRef = useRef(null);

  const scrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const module_training = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 600,
    afterChange: (current) => setCurrentSlide(current),
    slidesToShow: Mobile_Screen <= 480 ? 2 : 3,
    slidesToScroll: 1,
  };

  const handleChange = (e) => {
    setStudentForm({ ...StudentForm, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      Test_Book({
        ...StudentForm,
        Location: "Delhi",
        url: window.location.href,
      })
    );
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (success) {
      setStudentForm({ ...DetailsFormJSon });
      setTimeout(() => {
        dispatch({ type: TEST_BOOKING_RESET });
      }, 6000);
    }

    // if (error) {
    // }
  }, [success, dispatch]);

  return (
    <div>
      <Helmet>
        {/* <!-- Primary Meta Tags --> */}
        <meta
          name="title"
          content="Best IELTS Coaching in Delhi | Testifyi – 8+ Band Results"
        />
        <meta
          name="description"
          content="Looking for the best IELTS coaching in Delhi? Testifyi offers expert guidance, flexible batches, and proven 8+ band results."
        />
        <meta
          name="keywords"
          content="Book Test for IELTS & PTE, IELTS Reality Test, PTE Reality Test, IELTS & PTE reality test, testifyi reality test, TRT test, IELTS Coaching"
        />

        {/* <!-- Canonical --> */}
        <link
          rel="canonical"
          href="https://testifyi.com/ielts-coaching-in-delhi"
        />

        {/* <!-- Robots --> */}
        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />

        {/* <!-- Open Graph / Facebook --> */}
        <meta
          property="og:title"
          content="Best IELTS Coaching in Delhi | Testifyi – 8+ Band Results"
        />
        <meta
          property="og:description"
          content="Looking for the best IELTS coaching in Delhi? Testifyi offers expert guidance, flexible batches, and proven 8+ band results."
        />
        <meta
          property="og:url"
          content="https://testifyi.com/ielts-coaching-in-delhi"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://testifyi.com/assets/images/Banner.png"
        />

        {/* <!-- Twitter Card --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Best IELTS Coaching in Delhi | Testifyi – 8+ Band Results"
        />
        <meta
          name="twitter:description"
          content="Looking for the best IELTS coaching in Delhi? Testifyi offers expert guidance, flexible batches, and proven 8+ band results."
        />
        <meta
          name="twitter:image"
          content="https://testifyi.com/assets/images/Banner.png"
        />

        {/* <!-- Viewport --> */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* <!-- Language --> */}
        <meta http-equiv="Content-Language" content="en" />

        {/* <!-- Charset --> */}
        <meta charset="UTF-8" />

        {/* <!-- Theme Color (optional for browsers/mobile UI) --> */}
        <meta name="theme-color" content="#0A3AFF" />

        {/* <!-- Favicon (update with your actual path) --> */}

        <meta name="robots" content="index, follow" />
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="language" content="English" />
        <meta name="revisit-after" content="1 days" />
        <meta name="author" content="Testifyi" />
        <title>Best IELTS Coaching in Delhi | Testifyi – 8+ Band Results</title>
      </Helmet>
      {loading ? <Loading /> : ""}
      <Navbar2 />
      <div className="Delhi_Ielts">
        {/* <!-- Banner Section --> */}
        <section class="banner">
          <div class="container">
            <div class="banner-content">
              <div class="banner-left">
                <h1>IELTS Coaching in Delhi - Testifyi</h1>
                <h2>
                  8+ Band in First Attempt – Delhi's Trusted IELTS Institute
                </h2>

                <div class="stats-grid">
                  <div class="stat-item">
                    <div class="stat-icon">
                      <FaTrophy color="#FACC15" />
                    </div>
                    <div class="stat-info">
                      <div class="stat-number">8+ Band</div>
                      <div class="stat-label">Success Rate</div>
                    </div>
                  </div>
                  <div class="stat-item">
                    <div class="stat-icon">
                      <FaUsers color="#14B8A6" />
                    </div>
                    <div class="stat-info">
                      <div class="stat-number">1000+</div>
                      <div class="stat-label">Students Trained</div>
                    </div>
                  </div>
                  <div class="stat-item">
                    <div class="stat-icon">
                      <FaBookOpen color="#FDE68A" />
                    </div>
                    <div class="stat-info">
                      <div class="stat-number">Expert</div>
                      <div class="stat-label">Trainers</div>
                    </div>
                  </div>
                  <div class="stat-item">
                    <div class="stat-icon">
                      <FaRegClock color="#FB7185" />
                    </div>
                    <div class="stat-info">
                      <div class="stat-number">Flexible</div>
                      <div class="stat-label">Timings</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="banner-right">
                <div ref={formRef} class="form-container">
                  <h3>Start Your IELTS Journey Today!</h3>
                  <form class="contact-form" onSubmit={handleSubmit}>
                    <div class="form-group">
                      <label>Full Name *</label>
                      <input
                        type="text"
                        name="name"
                        value={StudentForm?.name}
                        onChange={handleChange}
                        placeholder="Enter your full name"
                        required
                      />
                    </div>
                    <div class="form-group">
                      <label>Email Address *</label>
                      <input
                        type="email"
                        name="email"
                        value={StudentForm.email}
                        onChange={handleChange}
                        placeholder="Enter your email"
                        required
                      />
                    </div>
                    <div class="form-group">
                      <label>Phone Number *</label>
                      <input
                        type="tel"
                        name="phone"
                        value={StudentForm.phone}
                        onChange={handleChange}
                        placeholder="Enter your phone number"
                        required
                      />
                    </div>
                    <div class="form-group">
                      <label>Preferred Timing</label>
                      <select
                        name="timeSlot"
                        value={StudentForm.timeSlot}
                        onChange={handleChange}
                      >
                        <option value="">Select preferred timing</option>
                        <option value=" Morning (9:00 AM - 12:00 PM)">
                          Morning (9:00 AM - 12:00 PM)
                        </option>
                        <option value=" Afternoon (2:00 PM - 5:00 PM)">
                          Afternoon (2:00 PM - 5:00 PM)
                        </option>
                        <option value="  Evening (6:00 PM - 9:00 PM)">
                          Evening (6:00 PM - 9:00 PM)
                        </option>
                        <option value="weekend">Weekend</option>
                      </select>
                    </div>
                    <div>
                      {error ? (
                        <p style={{ color: "red" }}> {error}</p>
                      ) : success ? (
                        <p style={{ color: "green" }}>{success}</p>
                      ) : (
                        ""
                      )}
                    </div>
                    <div class="form-buttons">
                      <button type="submit" class="btn btn-success">
                        Free Demo
                      </button>
                      <button type="submit" class="btn btn-primary">
                        Join Now
                      </button>
                    </div>
                  </form>
                  <p class="form-note">
                    <FaBullseye
                      color="#F97316"
                      style={{ marginBlock: "-2px" }}
                    />{" "}
                    Limited seats available |{" "}
                    <FaPhoneAlt
                      color="#10B981"
                      style={{ marginBlock: "-2px" }}
                    />{" "}
                    Immediate response guaranteed
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* 
    <!-- Why Choose Section --> */}
        <section class="why-choose">
          <div class="container">
            <div class="section-header">
              <h2>Why Choose Testifyi Delhi?</h2>
              <p>
                We combine proven methodologies with cutting-edge technology to
                deliver exceptional IELTS coaching results
              </p>
            </div>

            <div className="features-grid">
              <Slider style={{ width: "100%" }} {...why_choose}>
                <div>
                  <div class="feature-card">
                    <div class="feature-icon">
                      <LuTarget color="#EF4444" />
                    </div>
                    <h3>Proven 8+ Band Strategy</h3>
                    <p>
                      Our tested methodology has helped hundreds achieve 8+
                      bands in their first attempt with personalized study
                      plans.
                    </p>
                  </div>
                </div>
                <div>
                  <div class="feature-card">
                    <div class="feature-icon">
                      <MdLocationPin color="#EF4444" />
                    </div>
                    <h3>Delhi-based Trainers</h3>
                    <p>
                      Local expert trainers who understand the specific needs
                      and challenges of Delhi students.
                    </p>
                  </div>
                </div>{" "}
                <div>
                  <div class="feature-card">
                    <div class="feature-icon">
                      <MdOutlineEditNote color="#F59E0B" />
                    </div>
                    <h3>Mock Tests with Real-time Evaluation</h3>
                    <p>
                      Regular practice tests with immediate feedback and
                      detailed performance analysis to track your progress.
                    </p>
                  </div>
                </div>
                <div>
                  <div class="feature-card">
                    <div class="feature-icon">
                      <LuBot color="#D946EF" />
                    </div>
                    <h3>AI Feedback for Speaking & Writing</h3>
                    <p>
                      Advanced AI technology provides instant, detailed feedback
                      on your speaking fluency and writing skills.
                    </p>
                  </div>
                </div>
                <div>
                  <div class="feature-card">
                    <div class="feature-icon">
                      <LuUsers2 color="#14B8A6" />
                    </div>
                    <h3>Community-based Learning with Rewards</h3>
                    <p>
                      Join our active learning community with peer support,
                      group activities, and achievement rewards.
                    </p>
                  </div>
                </div>
              </Slider>
            </div>

            <div class="cta-box">
              <h3>Ready to Achieve Your Dream Score?</h3>
              <p>
                Join thousands of successful students who trusted Testifyi for
                their IELTS journey
              </p>
              <div class="cta-buttons">
                <button class="btn btn-white" onClick={(e) => scrollToForm()}>
                  Book Free Demo
                </button>
                <button class="btn btn-success">View Course Details</button>
              </div>
            </div>
          </div>
        </section>

        {/* <!-- Testimonials Section --> */}
        <section class="testimonials">
          <div class="container">
            <div class="section-header">
              <h2>Student Success Stories</h2>
              <p>
                Real students, real results. See how our students achieved their
                dream IELTS scores
              </p>
            </div>

            <div class="testimonials-grid">
              <Slider style={{ width: "100%", margin: "20px" }} {...why_choose}>
                <div>
                  <div class="testimonial-card">
                    <div class="testimonial-header">
                      <img
                        src="https://images.pexels.com/photos/1036623/pexels-photo-1036623.jpeg?auto=compress&cs=tinysrgb&w=150"
                        alt="Priya Sharma"
                      />
                      <div class="testimonial-info">
                        <h4>Priya Sharma</h4>
                        <div class="stars">⭐⭐⭐⭐⭐</div>
                        <p class="score-details">
                          L:8.5 | R:9.0 | W:8.0 | S:8.5
                        </p>
                      </div>
                    </div>
                    <div class="score-badge">Overall Band 8.5</div>
                    <p class="testimonial-text">
                      "Testifyi's personalized approach helped me achieve my
                      dream score! The mock tests and AI feedback were
                      game-changers. I got 8.5 overall in my first attempt."
                    </p>
                    <div class="verified">✅ Verified Student Result</div>
                  </div>
                </div>
                <div>
                  <div class="testimonial-card">
                    <div class="testimonial-header">
                      <img
                        src="https://images.pexels.com/photos/1222271/pexels-photo-1222271.jpeg?auto=compress&cs=tinysrgb&w=150"
                        alt="Arjun Patel"
                      />
                      <div class="testimonial-info">
                        <h4>Arjun Patel</h4>
                        <div class="stars">⭐⭐⭐⭐⭐</div>
                        <p class="score-details">
                          L:8.0 | R:8.5 | W:7.5 | S:8.0
                        </p>
                      </div>
                    </div>
                    <div class="score-badge">Overall Band 8.0</div>
                    <p class="testimonial-text">
                      "The trainers at Testifyi Delhi are exceptional. Their
                      strategy for speaking and writing modules helped me
                      overcome my weaknesses and achieve band 8.0."
                    </p>
                    <div class="verified">✅ Verified Student Result</div>
                  </div>
                </div>

                <div>
                  <div class="testimonial-card">
                    <div class="testimonial-header">
                      <img
                        src="https://images.pexels.com/photos/1036623/pexels-photo-1036623.jpeg?auto=compress&cs=tinysrgb&w=150"
                        alt="Priya Sharma"
                      />
                      <div class="testimonial-info">
                        <h4>Priya Sharma</h4>
                        <div class="stars">⭐⭐⭐⭐⭐</div>
                        <p class="score-details">
                          L:8.5 | R:9.0 | W:8.0 | S:8.5
                        </p>
                      </div>
                    </div>
                    <div class="score-badge">Overall Band 8.5</div>
                    <p class="testimonial-text">
                      "Testifyi's personalized approach helped me achieve my
                      dream score! The mock tests and AI feedback were
                      game-changers. I got 8.5 overall in my first attempt."
                    </p>
                    <div class="verified">✅ Verified Student Result</div>
                  </div>
                </div>
                <div>
                  <div class="testimonial-card">
                    <div class="testimonial-header">
                      <img
                        src="https://images.pexels.com/photos/1222271/pexels-photo-1222271.jpeg?auto=compress&cs=tinysrgb&w=150"
                        alt="Arjun Patel"
                      />
                      <div class="testimonial-info">
                        <h4>Arjun Patel</h4>
                        <div class="stars">⭐⭐⭐⭐⭐</div>
                        <p class="score-details">
                          L:8.0 | R:8.5 | W:7.5 | S:8.0
                        </p>
                      </div>
                    </div>
                    <div class="score-badge">Overall Band 8.0</div>
                    <p class="testimonial-text">
                      "The trainers at Testifyi Delhi are exceptional. Their
                      strategy for speaking and writing modules helped me
                      overcome my weaknesses and achieve band 8.0."
                    </p>
                    <div class="verified">✅ Verified Student Result</div>
                  </div>
                </div>

                <div>
                  <div class="testimonial-card">
                    <div class="testimonial-header">
                      <img
                        src="https://images.pexels.com/photos/1239291/pexels-photo-1239291.jpeg?auto=compress&cs=tinysrgb&w=150"
                        alt="Simran Kaur"
                      />
                      <div class="testimonial-info">
                        <h4>Simran Kaur</h4>
                        <div class="stars">⭐⭐⭐⭐⭐</div>
                        <p class="score-details">
                          L:8.5 | R:8.5 | W:8.0 | S:8.5
                        </p>
                      </div>
                    </div>
                    <div class="score-badge">Overall Band 8.5</div>
                    <p class="testimonial-text">
                      "From 6.5 to 8.5 in just 8 weeks! The structured learning
                      path and continuous support from Testifyi made all the
                      difference. Highly recommended!"
                    </p>
                    <div class="verified">✅ Verified Student Result</div>
                  </div>
                </div>
              </Slider>
            </div>

            <div class="testimonials-cta">
              <h3>Join Our Success Stories</h3>
              <p>
                Over 1000+ students have achieved their dream scores with
                Testifyi
              </p>
              <button class="btn btn-white">Start Your Success Journey</button>
            </div>
          </div>
        </section>
        {/* 
    <!-- Course Overview Section --> */}
        <section class="course-overview">
          <div class="container">
            <div class="section-header">
              <h2>Course Overview</h2>
              <p>
                Comprehensive IELTS preparation covering all four modules with
                personalized attention and advanced tracking
              </p>
            </div>

            <div class="features-row">
              <div class="feature-item">
                <div class="feature-icon">
                  <FaBookOpen color="#3B82F6" />
                </div>
                <h3>GT & Academic IELTS</h3>
                <p>
                  Comprehensive training for both General Training and Academic
                  modules with specialized strategies for each.
                </p>
              </div>
              <div class="feature-item">
                <div class="feature-icon">
                  <FaCommentDots color="#06B6D4" />
                </div>
                <h3>Daily Doubt Sessions</h3>
                <p>
                  One-on-one doubt clearing sessions every day to ensure no
                  question goes unanswered.
                </p>
              </div>
              <div class="feature-item">
                <div class="feature-icon">
                  <FaChartBar color="#6366F1" />
                </div>
                <h3>Band Tracking Dashboard</h3>
                <p>
                  Real-time progress tracking with detailed analytics to monitor
                  your improvement across all modules.
                </p>
              </div>
            </div>
            <div class="modules-container">
              <h3>Module-wise Training Program</h3>
              <div class="modules-grid">
                <Slider
                  style={{ width: "100%", background: "white" }}
                  {...why_choose}
                >
                  <div>
                    <div class="module-card listening">
                      <div class="module-header">
                        <h4>Listening</h4>
                        <span class="duration">20 hours</span>
                      </div>
                      <ul class="module-topics">
                        <li>✓ Learn to understand accent</li>
                        <li>✓ Fill ups</li>
                        <li>✓ MCQ's</li>
                        <li>✓ Map/Diagram</li>
                      </ul>
                    </div>
                  </div>
                  <div>
                    <div class="module-card reading">
                      <div class="module-header">
                        <h4>Reading</h4>
                        <span class="duration">20 hours</span>
                      </div>
                      <ul class="module-topics">
                        <li>✓ Pro Tips</li>
                        <li>✓ Narrow down the search</li>
                        <li>✓ Learn to read specifically</li>
                        <li>✓ Solve all question types</li>
                      </ul>
                    </div>
                  </div>
                  <div>
                    <div class="module-card writing">
                      <div class="module-header">
                        <h4>Writing</h4>
                        <span class="duration">25 hours</span>
                      </div>
                      <ul class="module-topics">
                        <li>✓ Learn Parameters</li>
                        <li>✓ Complex/Compound Structures</li>
                        <li>✓ Structures Task-1 & Task-2</li>
                        <li>✓ Simplified writing Strategy</li>
                      </ul>
                    </div>
                  </div>
                  <div>
                    <div class="module-card speaking">
                      <div class="module-header">
                        <h4>Speaking</h4>
                        <span class="duration">20 hours</span>
                      </div>
                      <ul class="module-topics">
                        <li>✓ Criterias for assessment</li>
                        <li>✓ Vocabulary building/Pronunciation</li>
                        <li>✓ Learn to converse</li>
                        <li>✓ Speak in relevance</li>
                      </ul>
                    </div>
                  </div>
                </Slider>
              </div>

              <div class="course-summary">
                <h4>Complete Course Duration</h4>
                <p>
                  6-8 weeks intensive program | 85+ hours of training |
                  Unlimited practice materials
                </p>
                <div class="summary-buttons">
                  <button class="btn btn-white">Download Curriculum</button>
                  <button
                    class="btn btn-warning"
                    onClick={() => scrollToForm()}
                  >
                    Book Free Trial Class
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <!-- Batch Schedule Section --> */}
        <section class="batch-schedule">
          <div class="container">
            <div class="section-header">
              <h2>Batch Schedule</h2>
              <p>
                Choose from flexible timing options that fit your schedule.
                Small batch sizes ensure personalized attention.
              </p>
            </div>

            <div class="batches-grid">
              <Slider
                style={{ width: "100%", background: "white" }}
                {...why_choose}
              >
                <div>
                  <div class="batch-card morning">
                    <div class="batch-icon">
                      <FaSun color="#FACC15" />
                    </div>
                    <h3>Morning Batch</h3>
                    <div class="batch-time">
                      <FaClock
                        color="#FB7185"
                        style={{ marginBottom: "-2px" }}
                      />{" "}
                      9:00 AM - 12:00 PM
                    </div>
                    <p class="batch-days">Monday to Friday</p>
                    <div class="batch-details">
                      <div class="detail-row">
                        <span>Batch Size:</span>
                        <span>15 students max</span>
                      </div>
                      <div class="detail-row">
                        <span>Duration:</span>
                        <span>6-8 weeks</span>
                      </div>
                      <div class="detail-row">
                        <span>Availability:</span>
                        <span class="available">8 seats available</span>
                      </div>
                    </div>
                    <button class="btn btn-primary">Reserve Your Seat</button>
                  </div>
                </div>

                <div>
                  <div class="batch-card evening">
                    <div class="batch-icon">
                      <MdWbTwilight
                        color="#FB923C"
                        style={{ marginBottom: "-2px" }}
                      />
                    </div>
                    <h3>Evening Batch</h3>
                    <div class="batch-time">
                      <FaClock
                        color="#FB7185"
                        style={{ marginBottom: "-2px" }}
                      />{" "}
                      6:00 PM - 9:00 PM
                    </div>
                    <p class="batch-days">Monday to Friday</p>
                    <div class="batch-details">
                      <div class="detail-row">
                        <span>Batch Size:</span>
                        <span>15 students max</span>
                      </div>
                      <div class="detail-row">
                        <span>Duration:</span>
                        <span>6-8 weeks</span>
                      </div>
                      <div class="detail-row">
                        <span>Availability:</span>
                        <span class="available">5 seats available</span>
                      </div>
                    </div>
                    <button class="btn btn-primary">Reserve Your Seat</button>
                  </div>
                </div>

                <div>
                  <div class="batch-card weekend">
                    <div class="batch-icon">
                      <FaRegCalendarAlt color="#0EA5E9" />
                    </div>
                    <h3>Weekend Batch</h3>
                    <div class="batch-time">
                      <FaClock
                        color="#FB7185"
                        style={{ marginBottom: "-2px" }}
                      />{" "}
                      10:00 AM - 4:00 PM
                    </div>
                    <p class="batch-days">Saturday & Sunday</p>
                    <div class="batch-details">
                      <div class="detail-row">
                        <span>Batch Size:</span>
                        <span>15 students max</span>
                      </div>
                      <div class="detail-row">
                        <span>Duration:</span>
                        <span>6-8 weeks</span>
                      </div>
                      <div class="detail-row">
                        <span>Availability:</span>
                        <span class="available">12 seats available</span>
                      </div>
                    </div>
                    <button class="btn btn-primary">Reserve Your Seat</button>
                  </div>
                </div>
              </Slider>
            </div>
            <div class="upcoming-batches New_Table_class">
              <h3>Upcoming Batch Dates</h3>

              <div className="container">
                <div class="table-container">
                  <table class="batch-table">
                    <thead>
                      <tr className="">
                        <th>Batch Type</th>
                        <th>Start Date</th>
                        <th>Duration</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td data-label="Batch Type">Morning Batch</td>
                        <td data-label="Start Date">January 15, 2025</td>
                        <td data-label="Duration">6 weeks</td>
                        <td data-label="Status">
                          <span class="status-badge status-filling">
                            Filling Fast
                          </span>
                        </td>
                        <td data-label="Action">
                          <button class="enroll-btn">Enroll Now</button>
                        </td>
                      </tr>
                      <tr>
                        <td data-label="Batch Type">Evening Batch</td>
                        <td data-label="Start Date">January 20, 2025</td>
                        <td data-label="Duration">6 weeks</td>
                        <td data-label="Status">
                          <span class="status-badge status-available">
                            Available
                          </span>
                        </td>
                        <td data-label="Action">
                          <button class="enroll-btn">Enroll Now</button>
                        </td>
                      </tr>
                      <tr>
                        <td data-label="Batch Type">Weekend Batch</td>
                        <td data-label="Start Date">January 18, 2025</td>
                        <td data-label="Duration">8 weeks</td>
                        <td data-label="Status">
                          <span class="status-badge status-new">New Batch</span>
                        </td>
                        <td data-label="Action">
                          <button class="enroll-btn">Enroll Now</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="early-bird-offer">
                <h4>
                  <span>
                    <MdRocketLaunch color="#F97316" />
                  </span>{" "}
                  Early Bird Offer
                </h4>
                <p>
                  Register 1 week before batch start and get 20% discount + Free
                  study materials worth ₹5,000
                </p>
                <button class="btn btn-white">Claim Early Bird Offer</button>
              </div>
            </div>
          </div>
        </section>

        {/* <!-- Location Section --> */}
        <section class="location">
          <div class="container">
            <div class="section-header">
              <h2>Visit Our Delhi Center</h2>
              <p>
                Conveniently located in the heart of Delhi with easy access to
                public transport and parking
              </p>
            </div>

            <div class="location-content">
              {/* <div class="contact-info">
                <div class="contact-card">
                  <h3>Get in Touch</h3>
                  <div class="contact-item">
                    <div class="contact-icon">📍</div>
                    <div>
                      <h4>Address</h4>
                      <p>
                        SCO 45-46, Second Floor
                        <br />
                        Sector 17-C, Delhi
                        <br />
                        Punjab 160017, India
                      </p>
                    </div>
                  </div>
                  <div class="contact-item">
                    <div class="contact-icon">📞</div>
                    <div>
                      <h4>Phone</h4>
                      <p>
                        +91 98765 43210
                        <br />
                        +91 98765 43211
                      </p>
                    </div>
                  </div>
                  <div class="contact-item">
                    <div class="contact-icon">✉️</div>
                    <div>
                      <h4>Email</h4>
                      <p>
                        info@testifyi.com
                        <br />
                        Delhi@testifyi.com
                      </p>
                    </div>
                  </div>
                  <div class="contact-item">
                    <div class="contact-icon">🕒</div>
                    <div>
                      <h4>Operating Hours</h4>
                      <p>
                        Monday - Friday: 9:00 AM - 9:00 PM
                        <br />
                        Saturday - Sunday: 10:00 AM - 6:00 PM
                      </p>
                    </div>
                  </div>

                  <div class="directions-info">
                    <h4>🧭 How to Reach</h4>
                    <ul>
                      <li>• 2 minutes walk from Sector 17 Plaza</li>
                      <li>• Bus Stop: Sector 17 (50 meters away)</li>
                      <li>• Metro: Take bus from Delhi Railway Station</li>
                      <li>• Parking: Available at Sector 17 Plaza</li>
                    </ul>
                  </div>
                </div>

                <div class="counseling-cta">
                  <h3>🎯 Book a Free Counseling Session</h3>
                  <p>
                    Visit our center for personalized IELTS guidance and free
                    practice test
                  </p>
                  <button class="btn btn-white">Schedule Visit</button>
                </div>
              </div> */}

              <div class="map-section">
                <h3>Find Us on Map</h3>
                <div class="map-container">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3503.2431682741694!2d77.2504521!3d28.5486732!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce35adb1e9e1f%3A0xf8cd70d1f67432d3!2s38%2C%20Ansal%20Tower%2C%20115%2C%20Nehru%20Place%2C%20New%20Delhi%2C%20Delhi%20110019!5e0!3m2!1sen!2sin!4v1691654356789!5m2!1sen!2sin"
                    width="100%"
                    height="300"
                    style={{ border: "0" }}
                    allowfullscreen=""
                    loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
                <div class="map-buttons">
                  <a
                    class="btn btn-primary"
                    href="https://www.google.com/maps/dir/?api=1&destination=38+Ansal+Tower+115+Nehru+Place+New+Delhi+Delhi+110019"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span>
                      <FaCompass />{" "}
                    </span>{" "}
                    Get Directions
                  </a>
                  <a
                    class="btn btn-success"
                    href="tel:9289192873"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span>
                      {" "}
                      <FaPhone />{" "}
                    </span>{" "}
                    Call Now
                  </a>
                </div>
                <div class="pickup-service">
                  <h4>🚗 Free Parking Service</h4>
                  <p>
                    We provide free parking service for students from Panchkula,
                    Mohali, and nearby areas for the first class!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <!-- FAQ Section --> */}
        <section class="faq">
          <div class="container">
            <div class="section-header">
              <h2>Delhi Center FAQs</h2>
              <p>
                Get answers to commonly asked questions about our Delhi center
                and IELTS programs
              </p>
            </div>

            <div class="faq-content">
              <div class="faq-list">
                <h3>Frequently Asked Questions</h3>

                <div class="faq-item">
                  <button class="faq-question">
                    What is the duration of the IELTS course at Testifyi Delhi?
                    <span class="faq-icon">+</span>
                  </button>
                  <div class="faq-answer">
                    <p>
                      Our comprehensive IELTS course runs for 6-8 weeks
                      depending on your current level and target score. We offer
                      intensive programs that include 85+ hours of training with
                      flexible batch timings.
                    </p>
                  </div>
                </div>

                <div class="faq-item">
                  <button class="faq-question">
                    Do you provide study materials and practice tests?
                    <span class="faq-icon">+</span>
                  </button>
                  <div class="faq-answer">
                    <p>
                      Yes! We provide comprehensive study materials worth
                      ₹5,000, unlimited practice tests, mock examinations, and
                      access to our AI-powered feedback system for Speaking and
                      Writing modules.
                    </p>
                  </div>
                </div>

                <div class="faq-item">
                  <button class="faq-question">
                    What is the batch size at Testifyi Delhi center?
                    <span class="faq-icon">+</span>
                  </button>
                  <div class="faq-answer">
                    <p>
                      We maintain small batch sizes of maximum 15 students to
                      ensure personalized attention and effective learning. This
                      allows our trainers to focus on each student's individual
                      needs and progress.
                    </p>
                  </div>
                </div>

                <div class="faq-item">
                  <button class="faq-question">
                    Do you offer trial classes?
                    <span class="faq-icon">+</span>
                  </button>
                  <div class="faq-answer">
                    <p>
                      Absolutely! We offer free trial classes where you can
                      experience our teaching methodology, meet our trainers,
                      and assess the learning environment before enrolling in
                      the full course.
                    </p>
                  </div>
                </div>

                <div class="faq-item">
                  <button class="faq-question">
                    What facilities are available at the Delhi center?
                    <span class="faq-icon">+</span>
                  </button>
                  <div class="faq-answer">
                    <p>
                      Our center features air-conditioned classrooms, computer
                      lab for practice tests, library, free Wi-Fi, parking
                      facility, and a comfortable waiting area. We also have
                      dedicated speaking practice rooms.
                    </p>
                  </div>
                </div>

                <div class="faq-item">
                  <button class="faq-question">
                    Do you provide score guarantee?
                    <span class="faq-icon">+</span>
                  </button>
                  <div class="faq-answer">
                    <p>
                      While we cannot legally guarantee specific scores, our
                      proven 8+ band strategy has helped hundreds of students
                      achieve their target scores. We offer additional free
                      classes if you don't achieve your target in the first
                      attempt.
                    </p>
                  </div>
                </div>

                <div class="faq-help">
                  <h4>Still have questions?</h4>
                  <p>
                    Our counselors are available to answer all your queries
                    about IELTS preparation and course details.
                  </p>
                  <div class="help-buttons">
                    <button class="btn btn-primary">
                      Call +91 92891 92873
                    </button>
                    <button
                      class="btn btn-outline"
                      onClick={() => scrollToForm()}
                    >
                      Schedule Counseling
                    </button>
                  </div>
                </div>
              </div>

              <div class="facilities-list">
                <h3>Delhi Center Facilities</h3>

                <div class="facility-item">
                  <div class="facility-icon">
                    <span>
                      <FaBuilding color="#4B5563" />
                    </span>
                  </div>
                  <div>
                    <h4>Modern Infrastructure</h4>
                    <p>
                      Air-conditioned classrooms with latest audio-visual
                      equipment
                    </p>
                  </div>
                </div>
                <div class="facility-item">
                  <div class="facility-icon">
                    <span>
                      <FaSignal color="#10B981" />
                    </span>
                  </div>
                  <div>
                    <h4>Free Wi-Fi & Computer Lab</h4>
                    <p>
                      High-speed internet and dedicated computers for online
                      practice
                    </p>
                  </div>
                </div>
                {/* <div class="facility-item">
                  <div class="facility-icon">🚗</div>
                  <div>
                    <h4>Parking & Transport</h4>
                    <p>Free parking and pickup service from nearby areas</p>
                  </div>
                </div> */}
                <div class="facility-item">
                  <div class="facility-icon">
                    <span>
                      <FaMapMarkerAlt color="#EF4444" />
                    </span>
                  </div>
                  <div>
                    <h4>Prime Location</h4>
                    <p>
                      Located in Sector 17-C with easy access to public
                      transport
                    </p>
                  </div>
                </div>
                <div class="visit-center">
                  <h4>
                    <span>
                      {" "}
                      <FaBuilding />
                    </span>{" "}
                    <span> Visit Our Center</span>
                  </h4>
                  <p>
                    Experience our world-class facilities and meet our expert
                    trainers in person
                  </p>
                  <button class="btn btn-white" onClick={() => scrollToForm()}>
                    Book Center Visit
                  </button>
                </div>
                {/* <div class="location-tips">
                  <h4>📍 Easy to Find</h4>
                  <ul>
                    <li>• Just 2 minutes walk from Sector 17 Plaza</li>
                    <li>• Multiple bus routes available</li>
                    <li>• Landmark: Near HDFC Bank, Sector 17-C</li>
                    <li>• Free parking at Sector 17 Plaza</li>
                  </ul>
                </div> */}
              </div>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
}
